import Modal from "../../components/modal/modal.component";
import InputComponent from "../../components/input/input.component";
import SelectComponent from "../../components/select/select.component";
import DatepickerComponent from "../../components/datepicker/datepicker.component";
import { Controller, useForm } from "react-hook-form";
import TextareaComponent from "../../components/textarea/textarea.component";
import usePeriod from "../../hooks/period.use";
import { to } from "../../polyfill";
import Button from "../../components/button/button.component";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import { LoanPaymentService } from "../../services/operation/loan-payment";
import { useEffect } from "react";

function PaymentFormModal({ show, setShow, loan }: any) {
  const { currentPeriod } = usePeriod();

  const defaultValues = {
    loan: loan._id,
    date: "",
    type: "",
    amount: "",
    concept: "",
    receipt: "",
  };

  const {
    watch,
    setValue,
    trigger,
    reset,
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const submit = async (form: typeof defaultValues) => {
    const formData = new FormData();
    formData.append('loan', form.loan);
    formData.append('date', form.date);
    formData.append('type', form.type);
    formData.append('amount', form.amount);
    formData.append('concept', form.concept);
    formData.append('receipt', form.receipt[0]);

    const [error, data] = await to(LoanPaymentService.save(formData));
    if(error) {
      alert(error.message)
    } else {
      setShow(true)
      reset(defaultValues);
    }
  };

  return (
    <Modal show={show}>
      <div className="modal-header">
        <h3 className="modal-title">Agregar depósito</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-5">
          <Controller
            name="date"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <DatepickerComponent
                  label="Fecha de deposito *"
                  errors={error}
                  onChange={onChange}
                  value={value}
                />
                <InvalidFeedback error={error} />
              </>
            )}
          />
        </div>

        <div className="mb-5">
          <SelectComponent
            label="Tipo de pago *"
            data={[
              {
                value: "capital",
                text: "Capital",
              },
              {
                value: "interes",
                text: "Interés",
              },
            ]}
            {...register("type", { required: true })}
            errors={errors.type}
          />
        </div>

        <div className="mb-5">
          <InputComponent
            label="Monto *"
            {...register("amount", { 
              required: true, 
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message:
                  "Solo se permiten números y un máximo de dos decimales",
              }
            })}
            errors={errors.amount}
          />
        </div>

        <div className="mb-5">
          <TextareaComponent
            label="Concepto *"
            {...register("concept", { required: true })}
            errors={errors.concept}
          />
        </div>

        <div className="mb-5">
          <InputComponent
            type="file"
            label="Comprobante *"
            {...register("receipt", { required: true })}
            onFileError={() => {
              setValue('receipt', '');
              trigger('receipt');
            }}
            errors={errors.receipt}
          />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button
          className="btn btn-primary"
          disabled={!isValid}
          isLoading={isSubmitting}
          onClick={handleSubmit(submit)}
        >
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default PaymentFormModal;
